import { useEffect, useState } from "react"
import "./Policy.css"
import { useNavigate } from "react-router-dom"

export const ImportantNews = () => {

    const [show, setShow] = useState()
    const agreePolicy = () => {
        sessionStorage.setItem("agreeImportantNews", true)
    }

    const navigete = useNavigate()
    const toNav = (link) => {
        window.scrollTo(0, 0)
        navigete(link)
    }

    useEffect(() => {
        const status = sessionStorage.getItem("agreeImportantNews");

        // Определяем границы времени
        const start = new Date("2026-03-20T00:00:00"); // 20.12.25 16:00
        const end = new Date("2026-03-20T00:00:00");   // 14.02.26 00:00
        const now = new Date();

        // Проверяем, входит ли текущее время в диапазон
        const isTimeInRange = now >= start && now < end;

        if (status !== "true" && isTimeInRange) {
            setTimeout(() => {
                setShow('is-widget-open');
            }, 1000);
        }
    }, []);


    const close = () => {
        setShow(null)
        agreePolicy()
    }

    return (
        <>
        {show &&
            <div className={`${show} policy-widget`}>
                {/* <button className="widget__close" onClick={() => { close() }}>
                    <svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="12.25" height="12.312" viewBox="0 0 12.25 12.312">
                        <path fill="currentColor" d="M499.364,781.3l0.455-.454,11.817,11.816-0.455.455Zm0.455,11.772-0.455-.455L511.181,780.8l0.455,0.454Z" transform="translate(-499.375 -780.813)"></path>
                    </svg>
                </button> */}
                <div className="policy-wrapper">
                    <div className="policy-widget-container">
                        <div className="widget__item">
                            {/* <div className="policy-image">
                                <ConeStriped size={90} />
                            </div> */}
                            <div className="policy-text policy-text-icon text-justify">
                                <div className="mb-2 fs-6">
                                    Уважаемые гости!
                                </div>
                                <div className="mb-1 fw-bold">
                            По техническим причинам онлайн продажа билетов на сайте Ленинград Центра временно недоступна.
                            Забронировать билеты можно по тел. 8 (812) 242 99 99.
                                </div>
                                <div className="mb-1">
                                    Благодарим за понимание.
                                </div>
                                <div className="mt-2 me-auto text-end">
                                    <button className="btn btn-lc btn-lc-rounded" onClick={() => { close() }}>Понятно, спасибо</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        }
            {/* } */}
        </>
    )
}